import React from 'react';

// The original pair, and still the default: the revision surfaces that switch
// between plain text and a computed redline pass nothing and are unaffected by
// the `options` prop below.
const DEFAULT_OPTIONS = [
  { value: 'clean', label: 'Clean' },
  { value: 'changes', label: 'Changes' },
];

/**
 * A view switch rendered as one pill.
 *
 * The DEFAULT is decided by the caller, not by this component: "Changes" while
 * drafting, "Clean" once submitted for approval, back to "Changes" the moment a
 * gate sends it to the author. This component only renders whichever mode it's
 * given and reports clicks -- it has no opinion about workflow state, so
 * DocumentViewPage/RevisionViewPage/DocumentEditPage/RevisionEditPage each
 * decide their own default and stay the single source of that rule.
 *
 * `options` exists so the edit pages can reuse this pill -- and the same
 * .change-mode-toggle CSS -- for their Redline | List switch, rather than
 * growing a second near-identical component. It defaults to Clean | Changes so
 * the callers that predate it are untouched.
 */
function ChangeModeToggle({ mode, onChange, options = DEFAULT_OPTIONS }) {
  return (
    <div className="change-mode-toggle" role="group" aria-label="View mode">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={mode === option.value ? 'active' : ''}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default ChangeModeToggle;
